<section class="page">
  <header class="page-header">
    <h2>Cartouches en cours de livraison</h2>
    <p class="subtitle">Affiche les cartouches actuellement en cours de transit.</p>
  </header>

  <section class="panel">
    <div class="actions-row">
      <button type="button" (click)="refresh()" [disabled]="loading">
        {{ loading ? 'Chargement...' : 'Actualiser la liste' }}
      </button>
      <a class="action-link" routerLink="/intranet/gestion-stocks/cartouches/voir">Aller vers cartouches</a>
    </div>

    @if (error) {
      <p class="error">{{ error }}</p>
    }

    @if (loading) {
      <p class="meta">Chargement des cartouches en cours de livraison...</p>
    } @else if (items.length === 0) {
      <p class="meta">Aucune cartouche en cours de livraison.</p>
    } @else {
      <p class="meta">{{ items.length }} cartouche(s) en transit.</p>
      <div class="table-wrap">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Nom</th>
              <th>Statut</th>
            </tr>
          </thead>
          <tbody>
            @for (item of items; track item.id) {
              <tr>
                <td>{{ item.id }}</td>
                <td>{{ item.nom }}</td>
                <td>{{ item.statut_livraison_nom || '-' }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </section>
</section>
